import { c as _c } from "react/compiler-runtime";
import ButtonComponent, { IconSize } from '../button/button/button.component';
import LinkComponent, { LinkComponentLink } from '../link/link.component';
import React, { ReactElement, memo } from 'react';
import { useSelector, useStore } from 'react-redux';
import { ButtonType } from '../button/types/ButtonType';
import ConfigurableCmsValidity from '@spa/top-level-components/cms-page/metadata/configurable/configurable-cms-validity.component';
import { NamespacedIntl } from '@spa/lib/i18n/common/NamespacedIntl';
import classNames from 'clsx';
import selectSessionContent from '@spa/lib/store/session/selectors/selectSessionContent';
import selectShowOverheadComponent from '@spa/lib/store/session/selectors/selectShowOverheadComponent';
import { setContent } from '@spa/lib/store/session/sessionSlice';
import styles from './overhead.component.module.scss';
import useNamespacedIntl from '@spa/lib/i18n/client/hooks/useNamespacedIntl';
export interface Props {
  readonly text: string | null;
  readonly link: LinkComponentLink | null;
  readonly backgroundColor?: string | null;
  readonly editorMode: boolean;
  readonly dateTo: number | null;
  readonly dateFrom: number | null;
}
function OverheadComponent(t0) {
  const $ = _c(35);
  const {
    text,
    link,
    backgroundColor,
    editorMode,
    dateTo,
    dateFrom
  } = t0;
  const showBanner = useSelector(selectShowOverheadComponent);
  const color = backgroundColor ?? "black";
  const t1 = color === "black";
  const t2 = color === "orange";
  const t3 = color === "pink";
  const t4 = color === "green";
  let t5;
  if ($[0] !== t1 || $[1] !== t2 || $[2] !== t3 || $[3] !== t4) {
    t5 = classNames({
      [styles.overhead]: true,
      [styles["overhead--black"]]: t1,
      [styles["overhead--main"]]: t2,
      [styles["overhead--pink"]]: t3,
      [styles["overhead--green"]]: t4
    });
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const overheadClass = t5;
  const {
    formatMessage
  } = useNamespacedIntl("overhead");
  const store = useStore();
  const content = useSelector(selectSessionContent);
  let t6;
  if ($[5] !== content || $[6] !== store) {
    t6 = () => {
      store.dispatch(setContent({
        localChange: true,
        content: {
          ...content,
          showOverheadComponent: false
        }
      }));
    };
    $[5] = content;
    $[6] = store;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const closeOverhead = t6;
  let t7;
  if ($[8] !== text) {
    t7 = <div className={styles.text}>{text}</div>;
    $[8] = text;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== formatMessage) {
    t8 = formatMessage("closeOverhead");
    $[10] = formatMessage;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t8) {
    t9 = {
      src: "/assets/icons/close-icon.svg",
      alt: t8,
      width: 5,
      height: 5,
      unoptimized: true
    };
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== formatMessage) {
    t10 = formatMessage("closeOverhead");
    $[14] = formatMessage;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== closeOverhead || $[17] !== t10 || $[18] !== t9) {
    t11 = <div className={styles["overhead__close-btn"]}><ButtonComponent buttonType={ButtonType.AS_TEXT} iconLeft={t9} iconSize={IconSize.SMALL} onClick={closeOverhead} aria-label={t10} /></div>;
    $[16] = closeOverhead;
    $[17] = t10;
    $[18] = t9;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== overheadClass || $[21] !== t11 || $[22] !== t7) {
    t12 = <div className={overheadClass}>{t7}{t11}</div>;
    $[20] = overheadClass;
    $[21] = t11;
    $[22] = t7;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  const textContent = t12;
  let t13;
  if ($[24] !== dateFrom || $[25] !== dateTo || $[26] !== editorMode) {
    t13 = editorMode && <ConfigurableCmsValidity dateFrom={dateFrom} dateTo={dateTo} />;
    $[24] = dateFrom;
    $[25] = dateTo;
    $[26] = editorMode;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== link || $[29] !== showBanner || $[30] !== textContent) {
    t14 = showBanner && (link ? <LinkComponent link={link}>{textContent}</LinkComponent> : textContent);
    $[28] = link;
    $[29] = showBanner;
    $[30] = textContent;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t13 || $[33] !== t14) {
    t15 = <>{t13}{t14}</>;
    $[32] = t13;
    $[33] = t14;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  return t15;
}
export default memo(OverheadComponent);